<div class="mt-20">
  <div class="row middle-xs">
    <div class="col-xs-3">
      <div class="pageTitle" [id]="identifierService.titleId('directAlertNotif','title')" [innerHTML]="titleLabel">
        <!-- {{ labels['label.gb.alert_notif') }} -->
      </div>
    </div>
    <div class="col-xs-4">
      @if (profileMode()) {
        <div>
          @if (removeOverrideButtonDisplay()) {
<button (click)="removeOverride()" style="margin-right: 20px" class="override-button" mat-raised-button [id]="
                        identifierService.dropdownId(
                            'direct-alerts-notifications',
                            'remove_overrides'
                        )
                    "><!--removeOverrideButtonDisplay-->
              {{ labels['label.gb.remove_overrides'] }}
            </button>
          }
          @if (viewMode()) {
            <button (click)="setDisplayMode('edit')" color="primary" id="profileEditButton" mat-raised-button style="margin-right: 5px" [disabled]="!hasPatientDataEntryAccess">
              {{ labels['label.gb.edit'] }}
            </button>
          }
          @if (editMode()) {
            <button (click)="cancelEditClick()" color="accent" id="profileCancelButton" mat-raised-button class="mr-20">
              {{ labels['label.gb.button_cancel'] }}
            </button>
          }
          @if (editMode()) {
            <button (click)="save()" color="primary" id="profileSaveButton" mat-raised-button class="mr-20">
              {{ labels['label.gb.save'] }}
            </button>
          }
        </div>
      }
    </div>
    <div class="col-xs-5 end-xs">
      @if (profileMode()) {
        <div style="display: flex; justify-content: flex-end; right: 15px">
          <div class="figLink" id="printProfileLink" style="margin-left: 10px; margin-top: 10px" (click)="openPrintDialog()" id="direct-alerts-notif-print-profile">
            {{ labels['label.gb.print_profile'] }}
          </div>
          @if (viewMode()) {
<div class="figLink" id="releasePatientLink" (click)="releasePatient()" style="margin-left: 10px; margin-top: 10px" [ngStyle]="{
                    'pointer-events': isSP2CanEnroll ? 'auto' : 'none',
                    color: isSP2CanEnroll ? '#03a9f4' : '#9e9e9e'
                }">
              {{ labels['label.gb.release_patient'] }}
            </div>
          }
          @if (viewMode()) {
            <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="moreActionsLink">
              <a [id]="identifierService.buttonId('directAlertsNotifications', 'moreActions')" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">
                {{ labels['label.gb.more_actions'] }} &#8942;
              </a>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <mat-menu #menu="matMenu">
  <button id="reactivatePatientButton" (click)="reActivatePatient()" mat-menu-item [disabled]="!hasPatientDataEntryAccess">
    {{ labels['label.gb.reactivate_pat'] }}
  </button>
</mat-menu>
@if (displayMode == 'view') {
  <div>
    @if (isPatientRelease) {
      <div class="yellow-card">
        <span [id]="identifierService.labelId('directAlertNotif','releasePatientMsg')" [innerHTML]="releasePatientMsg"></span>
      </div>
    }
  </div>
}

<!-- Yellow banner message -->
@if (batterAdvisoryAlertEnabled) {
  <div class="pt-10">
    <!-- Yellow banner message msg.pa894-->
    @if (!fwPBDPatchFlg && !transmitterSWUpgraded && !transmitterSwNull) {
      <div class="yellow-card alert alert-warning">
        <div class="warning-msg" [id]="identifierService.labelId('directAlertNotif','msg894')" [innerHTML]="msg894Label"></div>
        <i class="fa fa-times succ" (click)="hideAlert()" aria-hidden="true"></i>
      </div>
    }
    <!-- Yellow banner message msg.pa895-->
    @if (!fwPBDPatchFlg && transmitterSWUpgraded) {
      <div class="yellow-card alert alert-warning">
        <div class="warning-msg" [id]="identifierService.labelId('directAlertNotif','msg895')" [innerHTML]="msg895Label"></div>
        <i class="fa fa-times succ" (click)="hideAlert()" aria-hidden="true"></i>
      </div>
    }
    <!-- Yellow banner message msg.pa896-->
    @if ((!transmitterSWUpgraded && fwPBDPatchFlg)) {
      <div class="yellow-card alert alert-warning">
        <div class="warning-msg" [id]="identifierService.labelId('directAlertNotif','msg896')" [innerHTML]="msg896Label"></div>
        <i class="fa fa-times succ" (click)="hideAlert()" aria-hidden="true"></i>
      </div>
    }
    <!-- Yellow banner message msg.pa893-->
    @if ((transmitterSWVersion == null && fwPBDPatchFlg==null) || (!fwPBDPatchFlg && transmitterSwNull) ) {
      <div class="yellow-card alert alert-warning">
        <div class="warning-msg warningtext" [id]="identifierService.labelId('directAlertNotif','msg893')" [innerHTML]="msg893Label"></div>
        <i class="fa fa-times succ" (click)="hideAlert()" aria-hidden="true"></i>
      </div>
    }
  </div>
}
<!-- Yellow banner message main container close -->

<mat-card appearance="outlined" class="flat" style="margin-top: 10px">
  <div class="alert-cont">
    <div class="row">
      <h2 class="col-xs-5 merlin-header removeOvrRideBtnWrap">
        <span [id]="identifierService.labelId('directAlertNotif','alertType')" [innerHTML]="labels['label.gb.alert_type'] | safe: 'html'"></span>
        <hr class="underline-style" />
      </h2>
      <h2 class="col-xs-4 merlin-header clasification-header text-center">
        <span [id]="identifierService.labelId('directAlertNotif','alertClassification')" [innerHTML]="labels['label.gb.alert_classification'] | safe: 'html'"></span>
        <hr class="underline-style" />
      </h2>
      @if (displayAlertGroupList.length == 0 && !isNGQDevice && !isICMDevice && !isAveirDevice) {
        <h2 [id]="identifierService.labelId('directAlertsNotifications', 'informPatientHeader')" class="col-xs-3 merlin-header inform-patient-header  text-center">
          {{ labels['label.gb.inform_patient'] }}
          <mat-icon class="p-l-10 questionMark qestIcon" [mdePopoverTriggerFor]="dataRatesPopover">
          </mat-icon>
          <mde-popover #dataRatesPopover="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverArrowOffsetX="15" mdePopoverPositionX="after" mdePopoverPositionY="above">
              <p [id]="identifierService.labelId('directAlertsNotifications', 'instructionalAlertEmergencyContact')"> {{ labels['label.gb.instructional_alert_emergency_contact'] }}</p>
        </mde-popover>
        <hr class="underline-style" />
      </h2>
    }
  </div>
  <div class="row">
    <div class="col-xs-5"></div>
    <div class="col-xs-4 flagGroup padding-0">
      <div class="row">
        <div class="col-xs-4 padding-0 text-center">
          <span class="flags">
            <mat-icon class="mat-error flag-icon">flag</mat-icon>
            <span [id]="identifierService.labelId('directAlertsNotifications', 'urgent')" class="off-btn-styl">
              {{ labels['label.gb.urgent'] }}
            </span>
          </span>
        </div>
        <div class="col-xs-4 padding-0 text-center">
          <span class="flags">
            <mat-icon class="mat-warning flag-icon">flag</mat-icon>
            <span [id]="identifierService.labelId('directAlertsNotifications', 'standard')" class="off-btn-styl">
              {{ labels['label.gb.standard'] }}
            </span>
          </span>
        </div>
        @if(!isAveirDevice) {
        <div class="col-xs-4 padding-1 text-center">
          <span class="off-btn-styl flags off" [id]="identifierService.labelId('directAlertNotif','dontSelect')"
            [innerHTML]="labels['label.gb.dont_select'] | safe: 'html'">
          </span>
        </div>
      }
      </div>



    </div>
    @if (displayAlertGroupList.length == 0 && !isNGQDevice && !isICMDevice && !isAveirDevice) {
      <div class="col-xs-3 info-check">
                <mat-checkbox class="flgCheckBox" (ngModelChange)="toggleDisplay($event)" [(ngModel)]="toggleDisplayFlg" [disabled]="disableSelectAllCheckBox || (functionMode === 'profile' &&
                displayMode === 'view')" color="primary" [id]="
                        identifierService.dropdownId(
                            'direct-alerts-notifications',
                            'checkBox'
                        )
                    "></mat-checkbox>&nbsp;
      </div>
    }
  </div>
  @if (
    displayAlertDetails.length != 0 &&
    displayAlertGroupList.length == 0 && !isNGQDevice && !isICMDevice
    ) {
    <div>
      <!-- Sub-category -->
      @for (d of displayAlertDetails; track d) {
        <div class="" (click)="changeEditFormDirty()">
          <!-- restricting lead assurance sub category from main list -->
          @if ( d?.alertMismatchCode ?
            ((d.alertSubCategoryCd == null && d.alertSubCategoryHeaderCd == null) ||
            d.alertSubCategoryCd != null || d.alertSubCategoryHeaderCd != null) :
            ((d.alertSubCategoryCd == null && d.alertSubCategoryHeaderCd == null) ||
            (d.alertSubCategoryCd != null && d.alertSubCategoryHeaderCd != null))) {
            <div class="row">
              @if (!d.threshold && !d.durationCd) {
                <div class="col-xs-5 noPadding row-border row-border-section">
                  <span class="acc-icon toggle-cont">
                    @if (
                      d.alertSubCategoryCd &&
                      d.alertSubCategoryHeaderCd
                      ) {
                      <span
                        (click)="toggleSubCategory = !toggleSubCategory"
                        class="toggle-icon"
                        >
                        @if (toggleSubCategory) {
                          <span>+</span>
                        }
                        @if (!toggleSubCategory) {
                          <span>-</span>
                        }
                      </span>
                    }
                  </span>
                  <span [id]="identifierService.labelId('directAlertsNotifications', 'alertDesc_' + d?.alertCode)">{{ d.alertDesc }}</span>
                  @if (tooltipsAlertCode.includes(d.alertCode)) {
                    <span>
                      <mat-icon
                        [mdePopoverTriggerFor]="rollOverInfoText"
                        class="p-l-10 questionMark"
                        style="margin-left: 5px"
                        >
                      </mat-icon>
                      <mde-popover
                        #rollOverInfoText="mdePopover"
                        [mdePopoverOverlapTrigger]="false"
                        mdePopoverPositionX="after"
                        mdePopoverPositionY="above"
                        mdePopoverArrowOffsetX="15"
                        >
                        <mat-card appearance="outlined" style="max-width: 500px">
                          <mat-card-content>
                            <div [id]="identifierService.labelId('directAlertNotif','rollOverText')"
                                            [innerHTML]="
                                                getRollOverText(d.alertCode)
                                            "
                            ></div>
                          </mat-card-content>
                        </mat-card>
                      </mde-popover>
                    </span>
                  }
                </div>
              }
              @if (d.threshold && d.durationCd) {
                <div class="col-xs-5 noPadding row-border row-border-section">
                  <!-- This is a placeholder for alignment's sake -->
                  <span class="acc-icon toggle-cont"></span>
                  <!-- Override symbol -->
                  @if (
                    d.threshold != defaultThreshold ||
                    d.durationCd != defaultDuration
                    ) {
                    <span>
                      ♦
                    </span>
                  }
                  <span>
                    @if (d.alertGroupId == 28) {
                      <mat-select disableOptionCentering [(ngModel)]="d.threshold" [disabled]="disableCheckBox()" class=" sm-select noPadding">
                        @for (t of bivthresholdList; track t) {
                          <mat-option [id]="identifierService.listitemId('directAlertsNotifications', 'bivThreshold_' + t)" [value]="t">
                            {{ t }}
                          </mat-option>
                        }
                      </mat-select>
                    }
                    {{ getText(d.alertDesc, 0) }}
                    @if (d.alertGroupId == 27) {
                      <mat-select disableOptionCentering [(ngModel)]="d.threshold" [disabled]="disableCheckBox()" class=" sm-select noPadding">
                        @for (t of rvthresholdList; track t) {
                          <mat-option [id]="identifierService.listitemId('directAlertsNotifications', 'rvThreshold_' + t)" [value]="t">
                            {{ t }}
                          </mat-option>
                        }
                      </mat-select>
                    }
                  </span>
                  {{ getText(d.alertDesc, 1) }}
                  <mat-select disableOptionCentering [(ngModel)]="d.durationCd" [disabled]="disableCheckBox()" class=" sm-select noPadding">
                    @for (t of durationList; track t) {
                      <mat-option [id]="identifierService.listitemId('directAlertsNotifications', 'durationOption_' + t.codeId)" [value]="t.codeId">
                        {{ t.code }}
                      </mat-option>
                    }
                  </mat-select>
                  {{ getText(d.alertDesc, 2) }}
                </div>
              }
              <div class="col-xs-4 row-border">
                <mat-radio-group (ngModelChange)="severityChange($event, d)" [(ngModel)]="d.severityCd" class="row margin-top-5">
                  @for (type of severityOptions; track type) {
                    <div class="col-xs-4 text-center">
                                <mat-radio-button [id]="identifierService.checkboxId('directAlertNotif','severityOption_' + d.alertCode + '_' + type.codeId)" [disabled]="
                                        disableCheckBox(
                                            d.notifyPatientUiInactiveFlg
                                        )
                                    " [value]="type.codeId" color="primary" style="margin-left: 0px" class="radio-btn">
                        @if (
                          d.severityCd != d.defaultSeverityCd &&
                          type.codeId == d.severityCd
                          ) {
                          <span class="radioOverRide">♦</span>
                        }
                      </mat-radio-button>
                    </div>
                  }
                </mat-radio-group>
              </div>
              @if(!isAveirDevice){
              <div class="col-xs-3 info-check main-check row-border margin-top-5">
                <mat-checkbox [id]="identifierService.checkboxId('directAlertNotif','displayFlg_d')"
                  (ngModelChange)="displayChange($event, d)"
                  [(ngModel)]="d.displayFlg"
                            [disabled]="
                                severityCodeDisable(
                                    d.severityCd,
                                    d.notifyPatientUiInactiveFlg
                                )
                            "
                  class="infoCheck"
                  color="primary"
                  >
                  <span [id]="identifierService.labelId('directAlertsNotifications', 'displayFlgChanged')" class="selItemHighlight">
                    {{
                    d.displayFlg != d.defaultDisplayFlg ? '♦' : ' '
                  }}</span>
                </mat-checkbox>
              </div>
            }
            </div>
          }
          @if (
            d.alertSubCategoryCd &&
            d.alertSubCategoryHeaderCd &&
            !toggleSubCategory
            ) {
            <div
              class=""
              >
              @for (s of subCategoryGroup; track s) {
                <div
                  class="row row-border-section"
                  >
                  <div [id]="identifierService.labelId('directAlertsNotifications', 'subCategoryItem_' + s.alertDesc)" class="col-xs-5 subCategoryItem row-border">
                    - {{ s.alertDesc }}
                  </div>
                  <div class="col-xs-4 subInfoCheck row-border">
                    <mat-radio-group (ngModelChange)="severityChange($event, s)" [(ngModel)]="s.severityCd" class="row">
                      @for (type of severityOptions; track type) {
                        <div class="col-xs-4 text-center margin-top-1">
                                        <mat-radio-button [id]="identifierService.checkboxId('directAlertNotif','severityOption_' + s.alertCode + '_' + type.codeId)" [disabled]="
                                        disableCheckBox(
                                            s.notifyPatientUiInactiveFlg
                                        )
                                    " [value]="type.codeId" color="primary" class="radioBtn" style="margin-left: 0px">
                            @if (
                              s.severityCd !=
                              s.defaultSeverityCd &&
                              type.codeId == s.severityCd
                              ) {
                              <span class="sub-radioOverRide">♦</span
                                >
                              } </mat-radio-button>
                            </div>
                          }
                        </mat-radio-group>
                      </div>
                      <div class="col-xs-3 sub-info-check row-border margin-top-1">
                        <mat-checkbox [id]="identifierService.checkboxId('directAlertNotif','displayFlg_s')"
                          (ngModelChange)="displayChange($event, s)"
                          [(ngModel)]="s.displayFlg"
                                [disabled]="
                                    severityCodeDisable(
                                        s.severityCd,
                                        s.notifyPatientUiInactiveFlg
                                    )
                                "
                          color="primary"
                          >
                          <span [id]="identifierService.labelId('directAlertsNotifications', 'subDisplayFlgChanged')" class="selItemHighlight-sub">
                            {{
                            s.displayFlg != s.defaultDisplayFlg ? '♦' : ' '
                          }}</span>
                        </mat-checkbox>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      <!-- Alert groups -->

      @if (
        displayAlertDetails.length != 0 &&
        displayAlertGroupList.length != 0
        ) {
        <div>
          @for (alert of displayAlertGroupList; track alert) {
            <div>
              <p [id]="identifierService.labelId('directAlertsNotifications', 'alertGroupName_' + alert?.displayName)" class="row merlin-header ngq-header">{{ labels[alert.displayName]}}</p>
              @for (d of alert.groupInfo; track d) {
                <div class="row">
                  <div [id]="identifierService.labelId('directAlertsNotifications', 'ngqAlertDesc_' + d.alertDesc)" class="col-xs-5 ngq-desc row-border">
                    {{ d.alertDesc }}
                  </div>
                  <div class="col-xs-4 gallent-opt row-border">
                    <mat-radio-group (ngModelChange)="severityChange($event, d)" [(ngModel)]="d.severityCd" class="row">
                      @for (type of severityOptions; track type) {
                        <div class="col-xs-4 text-center margin-top-5">
                          @if (!(d?.alertCode === 1006 && type?.codeId === 988)) {
<mat-radio-button [id]="identifierService.checkboxId('directAlertNotif','severityOption_' + d.alertCode + '_' + type.codeId)" [disabled]="
                                    disableCheckBox(
                                        d?.notifyPatientUiInactiveFlg ?? undefined, d
                                    )
                                " [value]="type.codeId" color="primary" style="margin-left: 0px" class="radio-btn">
                              @if (
                                d.severityCd != d.defaultSeverityCd &&
                                type.codeId == d.severityCd
                                ) {
                                <span class="radioOverRide-ngq">♦</span
                                  >
                                  } </mat-radio-button
                                  >
                                }
                              </div>
                            }
                          </mat-radio-group>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (isICMDevice) {
              <div class="row col-xs-12 clinicRecordSymptomPlacement">
                <div class="clinicRecordSymptomOverride">
                @if (clinicRecordSymptomTxFlg !== effectiveRecordSymptomTxFlg) {
                  <span>♦</span>
                  } &nbsp;
                </div>
                  <mat-checkbox
                    [disabled]="displayMode === 'view'"
                    color="primary"
                    [checked]="effectiveRecordSymptomTxFlg"
                    [(ngModel)]="effectiveRecordSymptomTxFlg"
                    id="recordSymptomTxFlg"
                    (change)="recordSymptomChange($event)">
                    <span class="body-2" [id]="identifierService.labelId('directAlertNotif','symptomPaControl')"
                      [innerHTML]="labels['label.gb.symptom_PA_control'] | safe: 'html'">
                    </span>
                  </mat-checkbox>
                  <mat-icon class="questionMark clinicRecordSymptom" [mdePopoverTriggerFor]="recordSymptomTxFlgPopover">
                  </mat-icon>
                  <mde-popover #recordSymptomTxFlgPopover="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverPositionX="after" mdePopoverPositionY="above" mdePopoverArrowOffsetX="15">
                                    <p [id]="identifierService.labelId('directAlertNotif','enableSymptomTrans')" [innerHTML]="
                            labels[
                                'label.gb.instructional_enable_symptom_trans'
                  ]
                        ">
                    </p>
                </mde-popover>
              </div>
            }
            <br />
            <div class="row">
              <div class="col-xs-6">
                <div [id]="identifierService.labelId('directAlertsNotifications', 'overrideInstrText')" class="info mb-10">
                  {{ labels['label.gb.override_instr_text'] }}
                </div>
                <div [id]="identifierService.labelId('directAlertsNotifications', 'specialAlertNote')" class="special_alert_note body-2  mb-10">
                  {{ labels['label.gb.special_alert_note'] }}
                </div>
                @if (!bluetoothCapable) {
<div [id]="identifierService.labelId('directAlertsNotifications', 'instrAlertConfig')" class="info  mb-10" [innerHTML]="
                    labels['label.gb.instructional_alert_configuration']
                " id="direct-alert-instructional_alert_configuration"></div>
                }
              </div>
              <div class="col-xs-6">
                <div [id]="identifierService.labelId('directAlertsNotifications', 'tranSwVerNote')" class="info  mb-10">
                  {{ labels['label.gb.trans_sw_ver_note'] }}
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
